import React, { useEffect, useState } from "react";
import { Platform } from "react-native";
import { COLORS } from "../../constants";
import { isMobileWeb } from "../../utils/helper";

const InstallPromptWeb = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    // Detect if app is already installed or dismissed
    const isStandalone = window.matchMedia("(display-mode: standalone)").matches;

    if (isStandalone) {
      localStorage.setItem("vbgo_installed", "true");
    }

    if (
      Platform.OS !== "web" ||
      isStandalone ||
      localStorage.getItem("vbgo_installed") === "true" ||
      localStorage.getItem("vbgo_install_dismissed") === "true"
    ) {
      return;
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowPrompt(true);
    };

    window.addEventListener("beforeinstallprompt", handler);

    const fallbackTimeout = setTimeout(() => {
      if (!deferredPrompt && isMobileWeb) {
        setShowPrompt(true);
        localStorage.setItem("vbgo_prompt_was_shown", "true");
        sessionStorage.setItem("vbgo_session_suppress", "true");
      }
    }, 8000);

    return () => {
      clearTimeout(fallbackTimeout);
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, [deferredPrompt]);

  const handleClick = async () => {
    if (!deferredPrompt) {
      alert("To install, tap the browser menu and select 'Add to Home screen'");
      return;
    }

    setShowPrompt(false);
    deferredPrompt.prompt();

    const { outcome } = await deferredPrompt.userChoice;
    console.log(outcome === "accepted" ? "App installed!" : "Install dismissed");

    if (outcome === "accepted") {
      localStorage.setItem("vbgo_installed", "true");
    }

    setDeferredPrompt(null);
  };

  if (!showPrompt) return null;

  const label = isMobileWeb ? "Add to Home Screen" : "Install App";

  return (
    <div style={styles.banner}>
      <img src="/assets/icons/icon-96.webp" alt="VBGo" style={styles.icon} />
      <div style={styles.text}>
        <div style={styles.title}>VBGo</div>
      </div>
      <button style={styles.button} onClick={handleClick}>
        {label}
      </button>
      <button
        style={styles.close}
        onClick={() => {
          setShowPrompt(false);
          localStorage.setItem("vbgo_install_dismissed", "true");
        }}
      >
        ×
      </button>
    </div>
  );
};

const styles = {
  banner: {
    position: "fixed",
    bottom: 70,
    right: 16,
    backgroundColor: COLORS.backgroundGreen,
    border: "1px solid #277B33",
    borderRadius: 12,
    padding: isMobileWeb ? "12px 16px" : "14px 18px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    display: "flex",
    alignItems: "center",
    fontSize: isMobileWeb ? 14 : 14,
    zIndex: 9999,
    maxWidth: isMobileWeb ? "90%" : 460,
  },
  icon: {
    width: isMobileWeb ? 48 : 40,
    height: isMobileWeb ? 48 : 40,
    borderRadius: 8,
    marginRight: 12,
  },
  text: {
    flex: 1,
    fontSize: isMobileWeb ? 14 : 13,
    lineHeight: "1.2em",
  },
  title: {
    fontWeight: "bold",
    color: COLORS.textDark,
  },
  button: {
    backgroundColor: COLORS.primary,
    color: "white",
    border: "none",
    padding: isMobileWeb ? "8px 14px" : "8px 14px",
    borderRadius: 6,
    fontSize: 13,
    fontWeight: "bold",
    marginLeft: 12,
    cursor: "pointer",
  },
  close: {
    background: "none",
    border: "none",
    fontSize: 18,
    marginLeft: 10,
    cursor: "pointer",
    color: COLORS.border,
  },
};

export default InstallPromptWeb;
